// third party library
import React, { CSSProperties, FC, memo, useMemo } from 'react';
import cx from 'classnames';
//styles
import styles from './SkeletonLoader.module.scss';
import { TypographyHeight } from './SkeletonLoader.constant';
import { ILineLoader } from './types';

/*
 * numberOfLines: takes number of lines defaultValue = 1
 * containerStyle: container style
 * lineStyle: line style if you want
 * lineWidth: line loader width
 * dimenshionUnit: dimension of width defaultValue = "percentage"
 * childrenType: "H1" | "H2" | "H3" | "H4" | "H5" | "H6" | "P1" | "P2" | "P3" | "P4" | "P5" | "DISPLAY" defaultValue = "H2"
 */

const LineLoader: FC<ILineLoader> = props => {
  const {
    numberOfLines = 1,
    containerStyle,
    dimenshionUnit = 'percent',
    lineWidth,
    lineStyle,
    childrenType = 'H2'
  } = props;

  const computedStyle: CSSProperties = useMemo(() => {
    const styleObject: CSSProperties = {};
    if (lineStyle) return styleObject;
    if (lineWidth) styleObject.width = `${lineWidth}${dimenshionUnit}`;
    styleObject.height = TypographyHeight[childrenType];
    return styleObject;
  }, [lineWidth, dimenshionUnit]);

  const loaderLines: Array<JSX.Element> = useMemo(() => {
    const lines: Array<JSX.Element> = [];
    for (let line = 0; line < numberOfLines; line++)
      lines.push(
        <div key={line} style={{ ...computedStyle }} className={cx(styles.skeletonBox, lineStyle)}>
          <p>.</p>
        </div>
      );
    return lines;
  }, [numberOfLines]);
  return <div className={cx([styles.skeletonBoxContainer, containerStyle])}>{loaderLines}</div>;
};

export default memo(LineLoader);

/*
 * USAGE
    <LineLoader lineWidth={100} dimenshionUnit="px" numberOfLines={1} childrenType={"H1"} />
 *
*/
